import React from 'react';
import { Settings, Bell, Shield, Database, Palette, Globe } from 'lucide-react';
import { AdminCard, AdminPageHeader } from '../../../ui';

interface SettingSection {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  comingSoon?: boolean;
}

const SETTING_SECTIONS: SettingSection[] = [
  {
    id: 'general',
    title: 'Configurações Gerais',
    description: 'Configurações básicas do sistema',
    icon: <Settings className="w-6 h-6" />,
    comingSoon: true,
  },
  {
    id: 'notifications',
    title: 'Notificações',
    description: 'Gerenciar notificações e alertas',
    icon: <Bell className="w-6 h-6" />,
    comingSoon: true,
  },
  {
    id: 'security',
    title: 'Segurança',
    description: 'Configurações de segurança e autenticação',
    icon: <Shield className="w-6 h-6" />,
    comingSoon: true,
  },
  {
    id: 'integrations',
    title: 'Integrações',
    description: 'Conectar com serviços externos',
    icon: <Database className="w-6 h-6" />,
    comingSoon: true,
  },
  {
    id: 'appearance',
    title: 'Aparência',
    description: 'Personalizar a interface do sistema',
    icon: <Palette className="w-6 h-6" />,
    comingSoon: true,
  },
  {
    id: 'localization',
    title: 'Localização',
    description: 'Idioma e configurações regionais',
    icon: <Globe className="w-6 h-6" />,
    comingSoon: true,
  },
];

/**
 * SettingsManagement - Main settings page component
 */
export const SettingsManagement: React.FC = () => {
  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 py-6">
      <AdminPageHeader
        title="Configurações"
        subtitle="Gerencie as configurações do sistema"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {SETTING_SECTIONS.map((section) => (
          <AdminCard key={section.id} className="hover:border-[#F4CC04]/30 border border-transparent transition-colors cursor-pointer">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#1a1a1a] rounded-lg text-[#F4CC04]">
                {section.icon}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="text-lg font-medium text-white">
                    {section.title}
                  </h3>
                  {section.comingSoon && (
                    <span className="px-2 py-0.5 text-xs font-medium bg-[#F4CC04]/20 text-[#F4CC04] rounded-full">
                      Em breve
                    </span>
                  )}
                </div>
                <p className="text-sm text-[#888888] mt-1">
                  {section.description}
                </p>
              </div>
            </div>
          </AdminCard>
        ))}
      </div>
    </div>
  );
};

export default SettingsManagement;
